import { useI18n } from '@/i18n/I18nProvider';
import { legal, PRIVACY_LAST_UPDATED } from '@/i18n/legal';
import LegalPageShell from '@/components/site/LegalPageShell';
import LegalSections from '@/components/site/LegalSections';

export default function TermsPage() {
  const { locale } = useI18n();
  const copy = legal[locale].terms;

  return (
    <LegalPageShell
      testId="terms-page"
      titleTestId="terms-page-title"
      backTestId="terms-back-home"
      eyebrow={copy.eyebrow}
      title={copy.title}
      lead={copy.intro}
    >
      <LegalSections
        sections={copy.sections}
        locale={locale}
        sectionTestIdPrefix="terms-section"
      />
      <p className="text-xs uppercase tracking-[0.18em] text-muted-foreground/70 pt-10">
        {PRIVACY_LAST_UPDATED[locale]}
      </p>
    </LegalPageShell>
  );
}
